<template>
  <div v-cloak>
    <div class="vx-card mb-4">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body">
          <div class="vx-row">
            <div class="vx-col w-full">
              <form>
                <div class="vx-row mb-2">
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-input--label">{{ $t("SortingBy") }}</label>
                    <div class="w-full">
                      <v-select
                        label="name"
                        class="mb-4"
                        :options="sortingTypes"
                        @input="selectSortingType"
                        :reduce="x => x.id"
                        ref="sortingSelected"
                        :clearable="false"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-select--label datepicker-lb">{{
                      $t("FromDate")
                    }}</label>
                    <date-picker
                      v-model="gridSearchData.FromDate"
                      type="datetime"
                      format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss"
                      class="date-picker mb-4"
                      :label="$t('FromDate')"
                      :clearable="true"
                    />
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-select--label datepicker-lb">{{
                      $t("ToDate")
                    }}</label>
                    <date-picker
                      v-model="gridSearchData.ToDate"
                      type="datetime"
                      format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss"
                      class="date-picker mb-4"
                      :label="$t('ToDate')"
                      :clearable="true"
                    />
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-input--label">{{
                      $t("GenericProduct")
                    }}</label>
                    <div class="w-full">
                      <v-select
                        label="name"
                        name="cat"
                        class="mb-4"
                        :options="allGenericProducts"
                        :reduce="x => x.id"
                        v-model="gridSearchData.genericProductId"
                        v-validate="'required'"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-input--label">{{ $t("Brand") }}</label>
                    <div class="w-full">
                      <v-select
                        label="name"
                        class="mb-4"
                        name="brand"
                        :options="allBrands"
                        :reduce="x => x.id"
                        v-model="gridSearchData.brandId"
                        v-validate="'required'"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="lg:w-3/4 md:w-1/3 sm:w-1/2 w-full mt-6 px-2">
                    <vs-button
                      type="filled"
                      class="float-right"
                      @click.prevent="submitFilter()"
                      >{{ $t("SubmitFilter") }}</vs-button
                    >
                    <vs-button
                      type="filled"
                      class="float-right ml-4"
                      id="reset-btn"
                      @click.prevent="resetForm"
                      >{{ $t("ResetFilter") }}</vs-button
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mb-4">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body">
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-button
                @click="downloadFile()"
                class="bg_purple float-right mr-4"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("DownloadExcelFile") }}
              </vs-button>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mb-base">
              <data-grid
                ref="grid"
                stripe
                :data-source="gridDataSource"
                :search-data="gridSearchData"
                id="orderItemGrid"
                :columns="[
                  { title: $t('OrderId'), name: 'OrderId' },
                  { title: $t('CustomerName'), name: 'CustomerName' },
                  { title: $t('ProductName'), name: 'ProductName' },
                  { title: $t('ItemCode'), name: 'ItemCode' },
                  { title: $t('Count'), name: 'Count' },
                  { title: $t('UnitPrice'), name: 'UnitPrice' },
                  { title: $t('TotalAmount'), name: 'TotalAmount' },
                  { title: $t('SumOfDiscount'), name: 'SumOfDiscount' },
                  { title: $t('TotalTaxAmount'), name: 'TotalTaxAmount' },
                  { title: $t('TotalAmountWithTax'), name: 'Price' },
                  { title: $t('MoreDetails'), name: 'MoreDetails' }
                ]"
              >
                <template slot-scope="{ row }">
                  <td style="width: 5%">
                    {{ row.id }}
                  </td>
                  <td style="width: 10%">
                    {{ row.name }}
                  </td>
                  <td style="width: 18%">
                    {{ row.orderProductInfoQuery.productName }}
                  </td>
                  <td style="width: 7%">
                    {{ row.orderProductInfoQuery.itemCode }}
                  </td>
                  <td style="width: 3%">
                    {{ row.count }}
                  </td>
                  <td style="width: 9%">
                    {{ Number(row.unitPrice).toLocaleString() }} ریال
                  </td>
                  <td style="width: 12%">
                    {{ Number(row.totalAmount).toLocaleString() }} ریال
                  </td>
                  <td style="width: 8%">
                    <span v-if="row.sumOfDiscount">
                      {{ Number(row.sumOfDiscount).toLocaleString() }} ریال
                    </span>
                    <span v-else> - </span>
                  </td>
                  <td style="width: 9%">
                    {{ Number(row.totalTaxAmount).toLocaleString() }} ریال
                  </td>
                  <td style="width: 13%">
                    {{ Number(row.price).toLocaleString() }} ریال
                  </td>
                  <td style="width: 6%">
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      @click.prevent="showDetails(row)"
                      class="mx-4 d-inline"
                    ></vs-button>
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
          <details-popup
            :show="onShowDetails"
            :currentRow="currentRow"
            @finish="finish"
          ></details-popup>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
#orderItemGrid .vs-con-table td {
  padding: 4px !important;
}
#orderItemGrid .vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 0.95rem !important;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import DetailsPopup from "../DetailsPopup.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { mapGetters, mapActions } from "vuex";
import utils from "@/assets/utils/index";

export default {
  name: "saleManagement_Reports_Contract_OrderItems_Index",

  props: {
    contractId: {
      default: {}
    }
  },
  computed: {
    ...mapGetters({
      allBrands: "brand/list",
      allGenericProducts: "genericProduct/list"
    })
  },
  data() {
    return {
      onShowDetails: false,
      currentRow: {},
      gridDataSource: {
        type: "app",
        service: "Sales/api/OrdersQuery/orderItems/"
      },
      gridSearchData: {
        contractId: this.contractId
      },
      sortingTypes: [
        { name: "مبلغ کل(صعودی)", id: 1 },
        { name: "مبلغ کل(نزولی)", id: 2 },
        { name: "تعداد(صعودی)", id: 3 },
        { name: "تعداد(نزولی)", id: 4 }
      ]
    };
  },
  mounted() {
    this.fetchBrands();
    this.fetchGenericProducts();
  },
  methods: {
    ...mapActions({
      exportOrderItemsQueryExcel: "excel/exportOrderItemsQuery",
      fetchGenericProducts: "genericProduct/fetchNoSkip",
      fetchBrands: "brand/fetchNoSkip"
    }),
    showDetails(row) {
      this.currentRow = row;
      this.onShowDetails = true;
    },
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        FromDate: "",
        ToDate: "",
        SortingFieldName: "",
        SortingOrderType: ""
      };
      this.$refs.sortingSelected.clearSelection();
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
    selectSortingType(val) {
      if (val == 1) {
        this.gridSearchData.SortingFieldName = "TotalAmount";
        this.gridSearchData.SortingOrderType = "asc";
      }
      if (val == 2) {
        this.gridSearchData.SortingFieldName = "TotalAmount";
        this.gridSearchData.SortingOrderType = "desc";
      }
      if (val == 3) {
        this.gridSearchData.SortingFieldName = "Count";
        this.gridSearchData.SortingOrderType = "asc";
      }
      if (val == 4) {
        this.gridSearchData.SortingFieldName = "Count";
        this.gridSearchData.SortingOrderType = "desc";
      }
    },
    downloadFile() {
      var params = utils.toQueryString(this.gridSearchData);
      const contractId = this.contractId;
      this.exportOrderItemsQueryExcel({ contractId, params });
    },
    finish() {
      this.onShowDetails = false;
    }
  },
  components: {
    DataGrid,
    "v-select": vSelect,
    datePicker: VuePersianDatetimePicker,
    DetailsPopup
  }
};
</script>
